import React, { useState } from 'react';
import Logo from '../../../../assets/logo-novo-cointimes.svg';
import { Button } from '../../../UI';

import { CodeContainer } from './styles';

import { useForm, FormProvider } from '../../../../hooks/form';
import { Controller } from 'react-hook-form';
import { CircularProgress } from '@mui/material';
import { t } from 'i18next';

interface StepProps {
  prevFormStep?: () => void;
  errorCode: string;
  userEmail?: string;
  onSubmit?: (values?: any) => void;
  loading?: boolean;
}

const CodeField: React.FC<StepProps> = ({
  prevFormStep,
  userEmail,
  errorCode,
  onSubmit,
  loading,
}) => {
  const [code, setCode] = useState('');

  const methods = useForm();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = methods;

  const only6lenfg = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    const newValue = value.replace(/\D*/g, '');
    if (newValue.length <= 6) {
      setCode(newValue);
    }
  };

  return (
    <div className="rightContent">
      <div className="logo">
        <Logo height={60} />
      </div>
      <FormProvider {...methods}>
        <form className="register codeField" onSubmit={handleSubmit(onSubmit)}>
          <CodeContainer>
            <div className="alignInput">
              <span className="subTitle">{t('pages.forgot-password.enter-code-message')}</span>
              <div className="formContent">
                <Controller
                  name="recover_code"
                  render={({ field: { ref, onChange, ...field } }) => (
                    <input
                      min="0"
                      pattern="\d*"
                      value={code}
                      maxLength={6}
                      type="number"
                      inputMode="numeric"
                      autoComplete="off"
                      {...register('recover_code', { required: 'true' })}
                      onChange={only6lenfg}
                      onKeyPress={event => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                  )}
                />
                {errors.recover_code && (
                  <p className="warningTitle">{t('pages.forgot-password.enter-code-required')}</p>
                )}
                {!errors.recover_code && (
                  <p className="warningTitle">{errorCode}</p>
                )}
              </div>
            </div>

            <Button className="formButton" type="submit">
              {loading ? (
                <CircularProgress size={24} className="loading" />
              ) : (
                t('pages.forgot-password.confirm-code-button')
              )}
            </Button>
          </CodeContainer>
        </form>
      </FormProvider>
      <div className="alignButton">
        <Button
          className="button modal titleBack"
          onClick={prevFormStep}
          secondary
        >
          {t('pages.forgot-password.go-back')}
        </Button>
      </div>
    </div>
  );
};

export default CodeField;
